import React from 'react';
import { DefaultRecordType } from 'rc-table/lib/interface';

export const ReportDeviation = (value: any, record: DefaultRecordType) => (
  <React.Fragment>{((record.entryWeight - record.departureWeight - record.ttnSum) * 100) / 100000}</React.Fragment>
);
